import { useEffect } from 'react';

export function onMount(callback) {
  useEffect(callback, []);
}
